export const LANGUAGE_CODE_TO_TITLE = {
  hi: 'हिन्दी',
  en: 'English',
  bn: 'Bengali',
  mr: 'Marathi',
  te: 'Telugu',
  ta: 'Tamil',
  gu: 'Gujarati',
  kn: 'Kannada',
  ur: 'Urdu',
  or: 'Oriya',
  ml: 'Malayalam',
  pa: 'Punjabi',
  es: 'Spanish',
  fr: 'French',
  nl: 'Dutch',
  de: 'German',
  id: 'Bahasa Indonesia',
  sw: 'Swahili',
  ar: 'Arabic',
  ms: 'Malay'
};
